import VideoPopup from './class-popup';
$(() => {
  $(window).on('load', () => {
    $('.ct-link-button--popup, .video-popup').each((popupIndex, popupEl) => {
      const videoPopup = new VideoPopup(popupEl, popupIndex);
      popupEl.videoPopup = videoPopup;
    });
  });
});
